import React from 'react';
import PropTypes from 'prop-types';

const DoubleArrowLeft = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 477.2 477.2" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g>
        <g>
          <path d="M214.3,246.7l225.1,192c2.6,2.3,6.1,3.4,9.5,3.4s6.9-1.2,9.5-3.4c5.3-4.5,5.3-11.8,0-16.3L242.9,238.6L458.4,54.8
                    c5.3-4.5,5.3-11.8,0-16.3s-13.8-4.5-19.1,0l-225.1,192C209,234.9,209,242.3,214.3,246.7z" fill={color} />
        </g>
        <g>
          <path d="M18.8,246.7l225.1,192c2.6,2.3,6.1,3.4,9.5,3.4c3.4,0,6.9-1.2,9.5-3.4c5.3-4.5,5.3-11.8,0-16.3L47.4,238.6L262.9,54.8
                    c5.3-4.5,5.3-11.8,0-16.3s-13.8-4.5-19.1,0l-225.1,192C13.5,234.9,13.5,242.3,18.8,246.7z" fill={color} />
        </g>
      </g>
    </svg>
  );
}

DoubleArrowLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

DoubleArrowLeft.defaultProps = {
  color: '#000000',
  width: 477.2,
  height: 477.2,
};

export default DoubleArrowLeft;



// WEBPACK FOOTER //
// ./src/components/Icons/DoubleArrowLeft.jsx